// components/SoundCloudCallback.js
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

const SoundCloudCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const code = query.get('code');
    const state = query.get('state');

    const storedState = localStorage.getItem('sc_oauth_state');
    const codeVerifier = localStorage.getItem('sc_code_verifier');

    if (!code || !state) {
      alert('Missing code or state in URL');
      return;
    }

    if (state !== storedState) {
      alert('State mismatch. Possible CSRF attack.');
      return;
    }

    if (!codeVerifier) {
      alert('Missing code_verifier. Cannot complete OAuth.');
      return;
    }

    const exchangeToken = async () => {
      try {
        const response = await axios.post('/api/soundcloud/token', {
          code,
          code_verifier: codeVerifier,
        });

        // Optionally store token in memory or context if needed
        console.log('OAuth success:', response.data);

        // Cleanup sensitive data
        localStorage.removeItem('sc_code_verifier');
        localStorage.removeItem('sc_oauth_state');

        navigate('/artists');
      } catch (error) {
        console.error('OAuth token exchange failed:', error.response?.data || error.message);
        alert('SoundCloud authorization failed.');
      }
    };

    exchangeToken();
  }, [location, navigate]);

  return <p>Logging you in with SoundCloud...</p>;
};

export default SoundCloudCallback;